import { DialogType } from '@tableau/widgets';
import * as React from 'react';

import { Messages } from '~src/codegen/Localize';
import { areLinkedTasksEnabled } from '~src/linkedTasks/utils/LinkedTaskHelpers';
import { FeatureFlags } from '~src/ts/FeatureFlags';

import { ModalInstance, ReactModalOptions, ReactModalService } from '../../commonInfra/dialogs/ReactModalService';
import { FlowBaseInfo } from '../../ts/models/FlowInfo';
import { RunFlowTaskInfo } from '../../ts/models/RunFlowTaskInfo';
import { getFlowTaskDialog } from '../components/FlowTaskDialog';
import { RunFlowTaskDialogContent } from '../components/RunFlowTaskDialogContent';

export function getFlowRunSchedulesDialog(flowInfo: FlowBaseInfo, dismiss: () => void, outputId?: string): ReactModalOptions {
  return {
    type: DialogType.NormalWithTitleBar,
    title: Messages.newTask(),
    dialogContent: <RunFlowTaskDialogContent flowInfo={flowInfo} dismiss={dismiss} singleSelectedOutputId={outputId}/>,
    showCloseButton: true,
    dialogWidth: FeatureFlags.incrementalRefresh ? 900 : 600,
    shouldRecenterOnUpdate: true
  };
}

export function editFlowRunSchedulesDialog(taskInfo: RunFlowTaskInfo, dismiss: () => void): ReactModalOptions {
  return {
    type: DialogType.NormalWithTitleBar,
    title: Messages.editTask(),
    dialogContent: <RunFlowTaskDialogContent taskInfo={taskInfo} dismiss={dismiss}/>,
    showCloseButton: true,
    dialogWidth: FeatureFlags.incrementalRefresh ? 900 : 600,
    shouldRecenterOnUpdate: true
  };
}

export function openCreateFlowRunTaskDialog(flowInfo: FlowBaseInfo, outputId?: string): Promise<any> {
  let modalInstance: ModalInstance;
  const dismiss = () => modalInstance.dismiss();
  const dialog = areLinkedTasksEnabled() ?
    getFlowTaskDialog(flowInfo, dismiss, outputId) :
    getFlowRunSchedulesDialog(flowInfo, dismiss, outputId);
  modalInstance = ReactModalService.open(dialog);
  return modalInstance.result.catch(reason => {});
}

export function editFlowRunTaskDialog(flowTask: RunFlowTaskInfo): Promise<any> {
  let modalInstance: ModalInstance;
  const dismiss = () => modalInstance.dismiss();
  const dialog = editFlowRunSchedulesDialog(flowTask, dismiss);
  modalInstance = ReactModalService.open(dialog);
  return modalInstance.result.catch(reason => {});
}
